export { Soap } from './Soap';



// WEBPACK FOOTER //
// ./src/components/Soap/index.ts